export enum CampaignRelationshipStatusId {
  Active = 1,
  Removed = 2,
}
